import compareModule from '../scripts/compare/compare.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(compareModule);